import React from "react";
import MapArea from "./MapArea.jsx";
import Measure from "react-measure";
import MapObjectFilter from "./MapObjectFilter.jsx";
import StatusLegend from "./StatusLegend";


export default class Map extends React.Component {
    constructor() {
        super();

        this.isMeasured = false;

        this.state = {
            width: -1,
            height: -1,
            hoverObject: null,
        };

        this.updateDimensions = this.updateDimensions.bind(this);
        this.onRoomFilterChange = this.onRoomFilterChange.bind(this);
    }

    onRoomFilterChange(rooms) {
        this.props.onRoomFilterChange(rooms);
    }

    updateDimensions(dimensions) {
        const ratio = this.props.map.width / this.props.map.height;

        this.setState({
            width: dimensions.width,
            height: dimensions.width / ratio
        });

        this.props.onMapResize({
            width: dimensions.width,
            height: dimensions.width / ratio
        });
    }

    componentDidMount() {

    }

    componentDidUpdate(prevProps) {

    }

    shouldComponentUpdate(nextProps, nextState) {
        return true;
    }


    render() {
        if (!this.props.map) {
            return null;
        }

        const zoomLevel = this.state.width / this.props.map.width;

        const paths = this.props.map.regions.data.map((area) => {
            const visible = area.object ? this.props.visibleRooms.indexOf(area.object.data['rooms']) > -1 : false;
            const active = area.object ? this.props.hoverObject === area.object || this.props.showAll : false;

            return (
                <MapArea key={area.id} zoomLevel={zoomLevel} area={area}
                         active={active}
                         hoverObject={this.props.hoverObject}
                         hidden={!visible}
                         onMouseMove={this.props.onAreaMouseMove}
                         onMouseEnter={this.props.onAreaMouseEnter}
                         onMouseLeave={this.props.onAreaMouseLeave}
                         onAreaClick={this.props.onAreaClick}/>
            )
        });

        const style = {
            width: this.state.width + 'px',
            height: this.state.height + 'px',
        };

        return (
            <Measure onMeasure={this.updateDimensions}>
                <div className={this.state.height < 0 ? 'cw-map-hide' : ''}>
                    <div className="cw-map-header">
                        <MapObjectFilter objects={this.props.objects} visibleRooms={this.props.visibleRooms}
                                         roomsChange={this.onRoomFilterChange}/>
                        <StatusLegend objects={this.props.objects}  />
                    </div>

                    <div className="cw-map-wrap">
                        <img src={`${this.props.map.src}`} className="cw-map-image"
                             alt="Map"/>

                        <svg style={style}>
                            {paths}
                        </svg>

                        {this.props.children}
                    </div>
                </div>
            </Measure>)
    }
}



// WEBPACK FOOTER //
// ./src/components/Map.jsx